<template>
  <div>
    <div class="mb-2 image-counter">{{ imageCount }}</div>
    <div class="mb-3 image-container">
      <div
        v-for="(imageUrl, index) in imageUrls"
        :key="`url-${index}`"
        class="preview-image"
      >
        <img :src="imageUrl" width="100" height="100" class="image" />
        <sc-button
          v-if="!disabled"
          :id="index"
          class="btn-remove"
          @click="handleClickRemoveImageButton(index)"
          >x</sc-button
        >
      </div>
      <div
        v-for="(imageUrl, index) in previewImageUrls"
        :key="`preview-${index}`"
        class="preview-image"
      >
        <img :src="imageUrl" width="100" height="100" class="image" />
        <sc-button
          :id="index"
          class="btn-remove"
          @click="handleClickRemoveImagePreviewButton(index)"
          >x</sc-button
        >
      </div>
      <label
        v-if="showAddImageButton"
        for="image-input"
        class="sc-button primary add-image-button"
        accept="image/*"
        >+</label
      >
      <input
        id="image-input"
        :disabled="disabled"
        name="image-input"
        type="file"
        accept="image/*"
        style="display: none"
        @input="handleClickAddImagePreviewButton"
      />
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"

export default {
  components: {
    ScButton,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    imageUrls: {
      type: null,
      default: undefined,
    },
    maxNumberOfImages: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    previewImageUrls() {
      return this.value.map((file) => URL.createObjectURL(file))
    },
    imageCount() {
      return `${this.totalImages}/${this.maxNumberOfImages} รูป`
    },
    showAddImageButton() {
      return !this.disabled && !this.isMaxNumberOfImages
    },
    isMaxNumberOfImages() {
      return this.totalImages === this.maxNumberOfImages
    },
    totalImages() {
      return this.imageUrls.length + this.value.length
    },
  },
  methods: {
    handleClickAddImagePreviewButton(event) {
      if (this.isMaxNumberOfImages) {
        return
      }

      const imageFile = event.target.files[0]

      this.$emit("input", [...this.value, imageFile])
    },
    handleClickRemoveImagePreviewButton(index) {
      this.$emit(
        "input",
        this.value.filter((file, fileIndex) => fileIndex !== index),
      )
    },
    handleClickRemoveImageButton(index) {
      this.$emit("removeImage", index)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.image-counter {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: $border-radius;
  background: $secondary-color;
  color: $white;
  font-size: 0.75rem;
}

.add-image-button {
  display: flex;
  width: 6.25rem;
  height: 6.25rem;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px dashed #dddd;
  font-size: 2.5rem;
  color: #dddd;

  &:hover {
    color: darken(#dddd, 30%);
  }
}

.image-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  > .preview-image {
    margin-right: 0.875rem;
    margin-bottom: 0.875rem;
    position: relative;
    border-radius: 8px;
    border: 1px solid #dddd;

    > .image {
      border-radius: 8px;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.5);

      > .image {
        opacity: 0.5;
      }

      > .btn-remove {
        display: inline-block;
      }
    }

    > .btn-remove {
      display: none;
      position: absolute;
      padding: 0 5px;
      top: 0%;
      right: 0%;
      border: none;
      background: transparent;
      min-width: 0 !important;
      color: rgba(255, 255, 255, 0.5);

      &:hover {
        color: white;
        background: transparent;
      }
    }
  }
}
</style>
